var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ServiceCategory card",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"category"},[_c('img',{staticClass:"category__icon",attrs:{"src":_vm.icon}}),_vm._v(" "),_c('h4',{staticClass:"category__title",attrs:{"id":"js-test__title"}},[_vm._v("\n            "+_vm._s(_vm.title)+"\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ed3748a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services/ServiceCategory/index.vue
// module id = 1464
// module chunks = 1